import { SituacaoContribuinteEmpresaEnum } from '../../../enums/situacao-contribuinte-empresa.enum';
import { EmpresaLogoEdicaoStruct } from '../../structs/usuario/empresa-logo-edicao.struct';

export class EmpresaRequest {
    idEmpresa: number | null;
    nomeEmpresa: string;
    idEmpresaGrupo: number | null;
    idRevenda: number | null;
    cnpj: number;
    inscricaoEstadual: string | null;
    isAtivo: boolean;
    alterarMaster: boolean = false;
    idTimezone: number;

    // Endereco plano direto em `empresa`.
    cep: string | null;
    logradouro: string | null;
    numero: string | null;
    complemento: string | null;
    bairro: string | null;
    idMunicipio: number | null;
    idUnidadeFederativa: number | null;

    logo: EmpresaLogoEdicaoStruct | null;

    // lista modulo acesso empresa
    listaIdModuloAcesso: number[];

    //dados usuário master
    idUsuarioMaster: number | null;
    nomeUsuarioMaster: string | null;
    emailMaster: string | null;
    cpfMaster: string | null;
    telefoneMaster: string | null;
    senha: string | null;

    // Dados fiscais.
    nomeFantasia: string | null;
    dataFundacao: string | null;
    cnaePrincipal: string | null;
    idRegimeTributario: number | null;
    idRegimeApuracaoIrpj: number | null;
    /** Situação do contribuinte da empresa (SituacaoContribuinteEmpresaEnum). */
    idSituacaoContribuinteEmpresa: SituacaoContribuinteEmpresaEnum = SituacaoContribuinteEmpresaEnum.ContribuinteIcms;
    inscricaoMunicipal: string | null;
    inscricaoSuframa: string | null;
}
